import {Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from '../services/language.service';

@Pipe({name: 't', pure: false})
export class TranslatePipe implements PipeTransform {
  constructor(private readonly language: LanguageService) {
  }

  transform(key: string | null | undefined, params?: Record<string, string | number>): string {
    return this.language.translate(key, params);
  }
}
